import { Box, Container, Typography } from "@mui/material";
import logo from "../../logos/platform_logo.png";

function PageTitle({ title }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        marginLeft: "2%",
        marginRight: "2%",
      }}
    >
      <h1>{title}</h1>
      <Box
        component="img"
        src={logo}
        alt="logo"
        sx={{
          alignSelf: "center",
          maxWidth: "250px",
        }}
      />
    </Box>
  );
}

export default PageTitle;
